import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/ServicePage";
import { SERVICES } from "@/data/services";
import { buildServiceSchemas } from "@/lib/seo";

const SLUG = "gumiszereles-eger" as const;
const content = SERVICES.find((service) => service.slug === SLUG);
const url = `https://lakroszautoszerviz.com/${SLUG}`;

export const Route = createFileRoute("/gumiszereles-eger")({
  head: () => ({
    meta: [
      { title: content?.metaTitle ?? "Gumiszerelés Eger | LAKROSZ Autószerviz" },
      { name: "description", content: content?.metaDescription ?? "Gumiszerelés és centrírozás Egerben." },
      { property: "og:title", content: content?.metaTitle ?? "Gumiszerelés Eger | LAKROSZ Autószerviz" },
      { property: "og:description", content: content?.metaDescription ?? "Gumiszerelés és centrírozás Egerben." },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "LAKROSZ Autószerviz" },
      { property: "og:locale", content: "hu_HU" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: content?.metaTitle ?? "Gumiszerelés Eger | LAKROSZ Autószerviz" },
      { name: "twitter:description", content: content?.metaDescription ?? "Gumiszerelés és centrírozás Egerben." },
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: content ? buildServiceSchemas(content, url) : [],
  }),
  component: GumiszerelesPage,
});

function GumiszerelesPage() {
  if (!content) return null;
  return <ServicePage content={content} />;
}